
import Vue from 'vue';
import Vuex from 'vuex';
import createPersistedState from 'vuex-persistedstate';


Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        user: null,
        signedIn: false,
        userData: [],
        userEventdata: [],
        userASNs: [], // asns with alerts and count of alerts associated with this alert
        threshUser: [], //asn threshold values for all ases associated with a user
        allEvent: [],
        allAlert: [],
        ASNLength: [],
        AlertASN: [],
        statData: [],
        usrSpecASN: [],
        allASNInfoForUser: [],
        allASNInfoForOrg: [],
        top10alerts: [],
        systemStats: null,
        systemStatsUpdate: "",
        lastSearch: false,
        darkMode: false,
        alertsExcPath: false,
        alertsExcFirst: true,
        alertsExcInPath: true,
        alertsExcOwnAssert: true,
        textFormatting: {
            headers: {},
            main: {},
            dialog: {},
            traceroute: {
                width: 900,
                s_height: 280,
                a_height: 500,
                fontSize: 12,
                s_x: 0.2,
                s_y: 0.5,
                a_x: 0.15,
                a_y: 0.25,
            }
        },
        user_debug: {},
        orgASGroups: null,
        userASGroups: null,
        showSettings: {
            'gettingStarted': true,
            'advancedSettings': false,
            'clickthroughAdvFields': true,
            'autoMerge': false,
            'showRules': true,
            'showBubble': true,
            'showOrgResSummary': true,
            'showUserResSummary': true,
            'showOrgASNSummary': true,
            'showUserASNSummary': true,
        },
        userASNRules: [],
        orgASNRules: [],
        userPrefixRules: [],
        orgPrefixRules: [],
        searches: {
            'disag': false,
            'prefixRouting': false,
            'baseline': false,
            'countryASNs': false,
            'rawASN': false
        }
    },
    plugins: [
        createPersistedState()
    ],
    
    mutations: {

        setSearch(state, a) {
            const keys = Object.keys(a)
            for (var i = 0 ; i < keys.length ; i ++ ) {
                state.searches[keys[i]] = a[keys[i]];
            }
            
        },

        setShowSettings(state, a) {
            const keys = Object.keys(a)
            for (var i = 0 ; i < keys.length ; i ++ ) {
                state.showSettings[keys[i]] = a[keys[i]];
            }
            
        },

        setUserASNRules(state, a) {
            state.userASNRules = a;
        },

        setOrgASNRules(state, a) {
            state.orgASNRules = a;
        },

        setUserPrefixRules(state, a) {
            state.userPrefixRules = a;
        },

        setOrgPrefixRules(state, a) {
            state.orgPrefixRules = a;
        },

        setTextFormatting(state, a) {
            state.textFormatting = a;
        },

        setOrgASGroups(state, a) {
            state.orgASGroups = a;
        },

        setUserASGroups(state, a) {
            state.userASGroups = a;
        },

        setDarkMode(state, dm) {
            state.darkMode = dm;
        },

        setAlertsExcInPath(state, n) {
            state.alertsExcInPath = n;
        },
        setAlertsExcPath(state, n) {
            state.alertsExcPath = n;
        },
        setAlertsExcFirst(state, n) {
            state.alertsExcFirst = n;
        },
        setAlertsExcOwnAssert(state, n) {
            state.alertsExcOwnAssert = n;
        },

        addTop10Alerts(state, data) {
            state.top10alerts.push(data)
        },
        
        addAllASNInfoForUser(state, data) {
            state.allASNInfoForUser.push(data)
        },
        addUserData(state, data) {
        //this is the alert data, at a later point i need to go throuhg the whole instance and change name to userAlertData
        state.userData.push(data);
        },
        
        addUserEventData(state, data) {
            state.userEventdata.push(data);
        },
        addUserASNs(state, data) {
            var point = {asn: data.asn, count: data.count};
            state.userASNs.push(point);
            
        },
        addThreshASNs(state, data) {
            var point = {asn: data.asn, H: data.H, I: data.I, V: data.V, type: data.type, peering_asn: data.peering_asn}
            state.threshUser.push(point)
        },
        addAllEvent(state, data) {
        
            state.allEvent.push(data);
        },
        
        addAllAlert(state, data) {
            console.log(data)
            //state.allAlert.push(data);
        },
        signOut(state) {
            console.log("signing out")
            state.user = null;
            state.signedIn = false;
            state.userData = [];
            state.userEventdata = [];
            state.userASNs= [];
            state.allEvent= [];
            state.allAlert= [];
            state.orgASGroups = null;
            state.userASGroups = null;
            
        },
        ASNLength(state, data) {
            state.ASNLength.push(data);
        },
        AlertASN(state, data) {
            state.AlertASN.push(data);
        },
        addStatData(state, data){
            state.statData.push(data);
        }
    },
    
    actions: {
        
    },
})